/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type SomniaTokenListRequest = {
    sortField?: SomniaTokenListRequest.sortField;
    sortDirection?: SomniaTokenListRequest.sortDirection;
    tokenTypeList?: Array<'NA' | 'CA' | 'ERC20' | 'ERC721' | 'ERC1155'>;
    page?: number;
    size?: number;
};

export namespace SomniaTokenListRequest {

    export enum sortField {
        PRICE = 'PRICE',
        MARKET_CAP = 'MARKET_CAP',
        VOLUME = 'VOLUME',
        HOLDER = 'HOLDER',
        TOTAL_SUPPLY = 'TOTAL_SUPPLY',
    }

    export enum sortDirection {
        ASC = 'ASC',
        DESC = 'DESC',
    }


}

